import classNames from "classnames";

export type $Props = {
  label: string;
  id?: string;
  className?: string;
  required?: boolean;
  type?: string;
  placeholder?: string;
  onChangeText?: (value: string) => void;
  onChange?: (e: any) => void;
  name?: string;
  value?: string;
  autoFocus?: boolean;
  error?: string;
  disabled?: boolean;
  multiline?: boolean;
  readOnly?: boolean;
  onBlur?: (any) => void;
};

export default function TextInput({
  label,
  id,
  className = "u-mbottom24",
  required,
  readOnly,
  multiline,
  type,
  onChangeText,
  onChange,
  name,
  value,
  autoFocus,
  disabled,
  error,
  onBlur,
  ...props
}: $Props) {
  return (
    <div
      className={classNames(`input ${className && className}`, {
        "input--validation-symbolic-warning": error,
      })}
    >
      <label htmlFor={id} className="input__label">
        {label}

        {required && !readOnly && (
          <span className="input__label__required">required</span>
        )}
      </label>
      {readOnly && <p style={{ padding: 8 }}>{value}</p>}
      {!readOnly && !multiline && (
        <input
          {...props}
          onChange={(e) => {
            if (onChangeText) {
              onChangeText(e.target.value);
            }

            if (onChange) {
              onChange(e);
            }
          }}
          onBlur={(e) => {
            if (onBlur) {
              onBlur(e);
            }
          }}
          id={id}
          className="input__input"
          type={type || "text"}
          name={name}
          value={value}
          required={required}
          autoFocus={autoFocus}
          disabled={disabled}
        />
      )}
      {!readOnly && multiline && (
        <textarea
          {...props}
          onChange={(e) => {
            if (onChangeText) {
              onChangeText(e.target.value);
            }

            if (onChange) {
              onChange(e);
            }
          }}
          className="input__input"
          name={name}
          value={value}
          required={required}
          autoFocus={autoFocus}
          disabled={disabled}
        />
      )}
      {error && (
        <div className="input__validation">
          <small className="input__validation__message">
            <span className="help-block">{error}</span>
          </small>
        </div>
      )}
    </div>
  );
}
